<template>
  <el-dialog :title="title" :visible.sync="visible" :close-on-click-modal="false" append-to-body @opened="openFun">
    <el-form :model="entity" :rules="rules" ref="flowRef" label-width="120px">
      <el-form-item label="订单号" prop="orderNo">
        <el-input v-model="entity.orderNo" disabled></el-input>
      </el-form-item>
      <el-form-item label="归档凭证" prop="materialList">
        <el-upload
            class="upload-demo"
            action=""
            show-file-list
            :file-list="fileList"
            multiple
            :limit="10"
            :http-request="e => upload(e)"
            accept=""
        >
          <el-button type="primary" :loading="uploading">点击上传</el-button>
        </el-upload>
      </el-form-item>
      <el-form-item label="备注" prop="description">
        <el-input type="textarea" maxlength="255" show-word-limit v-model="entity.description"
                  placeholder="请输入备注"></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="resetForm('flowRef')">重置</el-button>
      <el-button type="primary" :loading="isLoading" @click="submitForm('flowRef')">确定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import {successMsg} from "@/utils/message";
import {upload} from "@/utils/oss";
import {orderAchieve} from "@/api/order/order";

export default {
  name: "orderArchiveDialog",
  components: {},
  props: {
    dialogVisible: {
      type: Boolean,
      require: true,
      default: false
    },
    orderNo: {
      type: String,
      require: true,
      default: ''
    }
  },
  computed: {
    visible: {
      get: function () {
        return this.dialogVisible
      },
      set: function (val) {
        this.$emit('update:dialogVisible', val)
      }
    }
  },
  data() {
    return {
      title: '归档',
      isLoading: false,
      uploading: false,
      fileList: [],
      entity: {
        orderNo: '',
        materialList: [],
        description: ''
      },
      rules: {
        orderNo: [{required: true, message: '订单号不能为空', trigger: 'blur'}],
        materialList: [{required: true, message: '请上传归档凭证', trigger: 'change'}],
      },
      options: []
    }
  },
  methods: {
    resetForm(formName) {
      this.entity = {
        orderNo: this.orderNo,
        materialList: [],
        description: ''
      }
      //清除验证
      this.$refs[formName].clearValidate()
    },
    openFun() {
      this.entity.orderNo = this.orderNo
    },
    //  提交
    submitForm(formName) {
      this.entity.materialList = this.fileList.map(item => item.url)
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.isLoading = true
          orderAchieve(this.entity).then(() => {
            successMsg('操作成功')
            this.visible = false
            this.$emit('operate:success')
            this.isLoading = false
          }).catch(() => {
            this.isLoading = false
          })
        }
      })
    },
    upload(e) {
      if (!e) {
        return
      }
      const file = e.file
      if (!file || !file.name) {
        return
      }
      this.uploading = true;
      upload(file)
          .then(url => {
            this.$message.success('上传成功')
            const fileObj = {
              name: file.name,
              url: url + '?' + file.name,
              uid: file.uid // 使用文件的 uid 作为唯一标识
            };
            this.fileList.push(fileObj);
            this.uploading = false;
          })
          .catch(err => {
            this.$message.error('上传失败：' + err)
            this.uploading = false;
          })
    }
  }
}
</script>

<style scoped>
::v-deep .vue-treeselect__control {
  height: 28px;
}

::v-deep .el-form-item__content {
  line-height: 28px;
  font-size: 12px;
}
</style>
